import players from "../jsonData/simulatorLineupData_MX.json";
import shareImage from "../../../assets/selection-mx/seleccion-mx-share.jpg";
import teamImage from "../../../assets/selection-mx/team-mx.png";

export const lineupMXConfig = {
  players,
  title: "Arma tu 11 ideal de la Selección Mexicana",
  accentColor: "var(--color-red)",
  pitchColor: ["#2d8a3e", "#27793a"],
  nameColor: "var(--color-black)",
  lastNameColor: "#27793a",
  shareImage,
  teamImage,
  backgroundTeam: "#043610b0",
  shareUrl: "futbol/mundial-2026/arma-tu-alineacion-ideal-de-mexico-para-el-mundial-2026-con-el-simulador-de-claro-sports/",
  shareText: "Mi 11 ideal de la selección Mexicana ",
  shareTitle: "Mi 11 ideal de la selección Mexicana ",
  shareFileName: "mi-11-ideal-mx.png",
  showClubToggle: false, // Mostrar botón para ver/ocultar club
  showNationalityToggle: false, // Mostrar botón para ver/ocultar nacionalidad
  selectionPath: "selection-mx", // Ruta de la carpeta de assets de la selección
  showFormationFilter: true, // Mostrar dropdown de alineación
  defaultFormation: "4-3-3", // Alineación por defecto
};
